import { useStore } from '@/store';
import { useRouter } from 'vue-router';
import AuthService from '@/services/authService';

export function useAuth() {
    // Usings
    const store = useStore();
    const router = useRouter();

    // Services
    const authService = new AuthService();

    function logout() {
        authService.Logout().finally(() => {
            store.currentUser = undefined;
            store.currentDebitor = undefined;
            // Clear the basket on logout to prevent state leakage
            store.basket = undefined;
            router.push({ name: 'loginForm', query: { ...router.currentRoute.value.query } });
        });
    }

    return {
        logout
    };
}
